import React, { useCallback, useState } from "react";

import LightboxModal from "components/common/gallery/LightboxModal";

const ImageLightbox = ({ children, image }) => {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => setOpen(true), [setOpen]);
  const onClose = useCallback(() => setOpen(false), [setOpen]);

  return (
    <>
      {children(onOpen)}
      <LightboxModal
        onClose={onClose}
        modalIsOpen={open}
        activePhoto={{ image }}
        photos={[]}
        actionablePhoto={false}
      />
    </>
  );
};

export default ImageLightbox;
